/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/castCrew/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/castCrew/desktop.app', exports: {} };
const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import castCrewTabs from '@take-2/fd-modules/movie/castCrew/castCrew.tabs';

function run() {
    checkDependencies(module.name, debugLog);
    castCrewTabs.init();
}
run();
export default {  };